export default __webpack_public_path__ + "static/media/1417.bf2e6130.png";